"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateUKTaxes = void 0;
var helpers_1 = require("../../helpers");
var ukConfig_1 = require("./ukConfig");
function calculateUKTaxes(input) {
    var incomes = input.incomes ? input.incomes : input.user.incomes;
    var salaryIncomes = incomes.filter(function (inc) { return inc.type === "W2"; });
    var totalSalaryIncome = salaryIncomes.reduce(function (prev, acc) { return prev + acc.value.presentValue; }, 0);
    var totalPreTaxDeduction = 0;
    var totalTaxes = 0;
    for (var i = 0; i < salaryIncomes.length; i++) {
        var formattedDeductions = (0, helpers_1.formatDeductionsForTaxCalculation)(input.user, input.user.incomes);
        var preTaxDeductions = formattedDeductions.filter(function (ded) { return ded.preTax; });
        totalPreTaxDeduction += preTaxDeductions.reduce(function (prev, acc) { return prev + acc.annualValue; }, 0);
    }
    console.log("PRETAX -->", totalPreTaxDeduction);
    var taxableIncome = totalSalaryIncome - totalPreTaxDeduction;
    for (var _i = 0, ukTaxBracket_1 = ukConfig_1.ukTaxBracket; _i < ukTaxBracket_1.length; _i++) {
        var interval = ukTaxBracket_1[_i];
        if (taxableIncome < interval[1]) {
            totalTaxes += (taxableIncome - interval[0]) * interval[2];
            break;
        }
        else {
            totalTaxes += (interval[1] - interval[0]) * interval[2];
        }
    }
    console.log(totalTaxes / 12);
    return { region: "UK", totalTaxes: totalTaxes / 12 };
}
exports.calculateUKTaxes = calculateUKTaxes;
